import type { PayoutInvoiceStatus } from '@/types/payout';

export const PAYOUT_INVOICE_STATUSES: PayoutInvoiceStatus[] = [
  'AVAILABLE',
  'ACCEPTED',
  'IN_PROGRESS',
  'SUCCESS',
  'DECLINED',
  'UNDER_REVIEW',
];

export const PAYOUT_INVOICE_STATUS_LABELS: Record<PayoutInvoiceStatus, string> = {
  AVAILABLE: 'Доступна',
  ACCEPTED: 'Принята',
  IN_PROGRESS: 'В работе',
  SUCCESS: 'Успешно',
  DECLINED: 'Отклонена',
  UNDER_REVIEW: 'На проверке',
};
